import styled from "styled-components";

export const Timer = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.secondary};
  line-height: 14px;
`;
